import { type FunctionComponent, useContext } from "react";
import { Redirect } from "react-router";

import { BuilderInfoContext } from "helpers/globalContext/BuilderInfoContext";
import { UserInfoContext } from "helpers/globalContext/UserInfoContext";

import { BTLoginTypes } from "types/enum";

import { routes } from "utilities/routes";

const RedirectToFrozenPage: FunctionComponent = () => {
    const builderInfoContext = useContext(BuilderInfoContext);
    const userContext = useContext(UserInfoContext);
    if (builderInfoContext?.loginsDisabled) {
        if (userContext?.loginType === BTLoginTypes.ALL && userContext?.orgLinks?.length === 0) {
            // BuilderInfo with no orglinks in context indicates we are viewing an external page while not authenticated
            return null;
        }
        if (userContext?.loginType === BTLoginTypes.BUILDER) {
            return <Redirect to={routes.account.frozen} />;
        } else {
            return <Redirect to={routes.account.frozenExternal} />;
        }
    }
    return null;
};

export default RedirectToFrozenPage;
